/* oxlint-disable */
import React from 'react';

import { PortableText } from 'next-sanity';
import { IoDocumentText } from 'react-icons/io5';

import { Button } from '@/components/ui/button';

const renderRulesAsHTML = (rules: any, tournament: any) => {
  if (!rules) return <p>El torneo no ha comenzado</p>;
  if (tournament?.isNetwork) {
    return <PortableText value={rules} />;
  }
  return JSON.parse(rules).blocks.map((block: any) => {
    return <div key={block.key}>{block.text}</div>;
  });
};

export const TyCEvent = ({
  tournament, isSidebarOpen, showMore, setShowMore,
}: { tournament: any, isSidebarOpen: boolean, showMore: boolean, setShowMore: (showMore: boolean) => void }) => {
  return (
    <div
      className={`${!isSidebarOpen ? 'pl-20 md:pl-72' : 'md:pl-20'} w-full pt-20 max-lg:pt-[4.2rem] space-y-12 px-4`}
    >
      <section className="space-y-6">
        <div className="flex items-center gap-4">
          <IoDocumentText className="text-sivarbet-primary text-3xl" />
          <h2 className="text-3xl font-bold max-md:text-xl">
            Terminos y condiciones
          </h2>
        </div>
        <div className={`space-y-4 ${!showMore ? 'h-72' : 'h-auto'}`}>
          <div className="text-muted-foreground max-md:text-sm">
            <p className="text-lg">
              {tournament?.rules && renderRulesAsHTML(tournament?.isNetwork ? tournament.rules : Object.values(tournament.rules)[0], tournament)}
            </p>
          </div>
        </div>
        <div className="flex justify-center">
          <Button
            size="lg"
            style={{ boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}
            className="bg-sivarbet-primary hover:bg-sivarbet-primary/30 shadow-xl shadow-slate-950"
            onClick={() => {
              return setShowMore(!showMore);
            }}
          >
            {showMore ? 'Ver menos' : 'Ver más'}
          </Button>
        </div>
      </section>
    </div>

  );
};
